import { radioButtonMediaInput } from '@utils/component-framework';
import { PostloadedImage } from '@utils/react';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateTaskEntryMutation } from '../../../../state/mutations/update-task-entry.js';
import { CircledAudioPlayer } from '../../../atom.audio/_audio-player.circled.js';
import { useInputState } from '../../hook.use-input-state.js';
import { MediaBox } from '../atom.media-box/_media-box.js';
import { image, audioPlayer } from './input.image.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ImageInput(props) {
  const update = useUpdateTaskEntryMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => radioButtonMediaInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const onChange = () => {
    update(props.taskEntryKey, prev => {
      const next = Object.fromEntries(Object.entries(prev ?? {}).filter(([, value]) => value.type !== "radio-button-media" || value.taskId !== props.taskId));
      return {
        ...next,
        [props.node.id]: {
          type: "radio-button-media",
          taskId: props.taskId,
          markedAsCorrectAnswer: !inputEntry?.markedAsCorrectAnswer
        }
      };
    });
  };
  const baseState = useInputState(props.node, inputEntry, {
    forceValidation: (node, entry) => !!entry?.markedAsCorrectAnswer
  });
  const state = (() => {
    if (baseState === "incorrect" && !inputEntry?.markedAsCorrectAnswer && props.node.correctAnswer) {
      return "should-have";
    }
    return baseState;
  })();
  return /*#__PURE__*/jsxs(MediaBox, {
    state: state,
    checked: !!inputEntry?.markedAsCorrectAnswer,
    onChange: onChange,
    orientation: props.orientation,
    theme: "rounded",
    allowClickOnBox: true,
    children: [/*#__PURE__*/jsx(PostloadedImage, {
      className: image,
      alt: props.node.altText ?? "",
      src: props.node.src,
      onReady: img => {
        const aspect = img ? img.naturalWidth / img.naturalHeight : 1;
        img?.style.setProperty("width", `${Math.min(200, img.naturalHeight) * aspect}px`);
      }
    }), props.node.audioSrc && /*#__PURE__*/jsx(CircledAudioPlayer, {
      className: audioPlayer,
      src: props.node.audioSrc
    })]
  });
}

export { ImageInput };
//# sourceMappingURL=input.image.js.map
